export const HELP_FORM = 'helpContactForm';

export const NAME_REQUIRED = 'Please enter your name';
export const INVALID_EMAIL = 'Please enter a valid email address';
export const MESSAGE_REQUIRED = 'Please enter a message telling us how we can help you';
export const PHONE_REQUIRED = 'Please enter a phone number so we can reach you';
export const CATEGORY_REQUIRED = 'Please select the type of project you are interested in';

export const ANONYMOUS_QUESTION_CATEGORIES = [{
  field: 'how',
  label: 'How do I...',
}, {
  field: 'other',
  label: 'Other question',
}, {
  field: 'bug',
  label: 'Bug report',
}, {
  field: 'suggestion',
  label: 'Suggestion',
}];

export const CLIENT_QUESTION_CATEGORIES = [{
  field: 'account',
  label: 'Account question',
}, {
  field: 'how',
  label: 'How do I...',
}, {
  field: 'project_extension',
  label: 'Extending my project',
  group: 'Project question'
}, {
  field: 'refund',
  label: 'Refund',
  group: 'Project question'
}, {
  field: 'wrapup',
  label: 'Wrap-up',
  group: 'Project question'
}, {
  field: 'other_project_client',
  label: 'Other',
  group: 'Project question'
}, {
  field: 'bug',
  label: 'Bug report',
  group: 'Other'
}, {
  field: 'suggestion',
  label: 'Suggestion',
  group: 'Other'
}, {
  field: 'other',
  label: 'Other',
  group: 'Other'
}];

export const CREATIVE_QUESTION_CATEGORIES = [{
  field: 'award',
  label: 'Award or payment question',
  group: 'Account question'
}, {
  field: 'account_verification',
  label: 'Account verification',
  group: 'Account question'
}, {
  field: 'reputation',
  label: 'Reputation score',
  group: 'Account question'
}, {
  field: 'wrapup',
  label: 'Wrap-up problem',
  group: 'Project question'
}, {
  field: 'fraud',
  label: 'Potential fraud',
  group: 'Project question'
}, {
  field: 'brief',
  label: 'Problem brief',
  group: 'Project question'
}, {
  field: 'other_project_creative',
  label: 'Other',
  group: 'Project question'
}, {
  field: 'bug',
  label: 'Bug report',
  group: 'Other'
}, {
  field: 'suggestion',
  label: 'Suggestion',
  group: 'Other'
}, {
  field: 'other',
  label: 'Other',
  group: 'Other'
}];

export const timeOptions = [{
  field: '9 am to 12 pm CST Weekdays',
  label: '9 am to 12 pm CST Weekdays',
}, {
  field: '12 pm to 5 pm CST Weekdays',
  label: '12 pm to 5 pm CST Weekdays',
}, {
  field: 'Weekday Evenings after 5 pm CST',
  label: 'Weekday Evenings after 5 pm CST',
}, {
  field: '9 am to 5 pm CST Saturday or Sunday',
  label: '9 am to 5 pm CST Saturday or Sunday',
}];



// WEBPACK FOOTER //
// ./help/constants.js